import config from 'config';

export default ['$http', '$q', '$window', 'tmIdentity', function ($http, $q, $window, tmIdentity){
    var userInfo;
    
    function urlBase64Decode(str) {
        var output = str.replace('-', '+').replace('_', '/');
        switch (output.length % 4) {
            case 0:
                break;
            case 2:
                output += '==';
                break;
            case 3:
                output += '=';
                break;
            default:
                throw 'Illegal base64url string!';
        }
        return window.atob(output);
    }
    
    function getClaimsFromToken(newToken) {
        var token = newToken || $window.localStorage['token'];
        var user = {};
        if (typeof token !== 'undefined') {
            var encoded = token.split('.')[1];
            user = JSON.parse(urlBase64Decode(encoded));
        }
        
        return user;
    }


    
    function login(username, password) {
        var deferred = $q.defer();
        
        $http.post(config.apiBase + '/account/login', {
            username: username,
            password: password
        }).then(function(result){
            if(result.data.success == true){
                
                userInfo = {
                    accessToken: result.data.token,
                    user: getClaimsFromToken(result.data.token)
                };
                $window.localStorage['token'] = result.data.token;
                $window.localStorage['user'] = JSON.stringify(result.data.user);
                $http.defaults.headers.common['x-access-token'] = result.data.token;
                
                tmIdentity.currentUser = userInfo;
                
                deferred.resolve(userInfo);
            } else {
                deferred.reject({success: false});
            }
            
            
            
        }, function(error) {
            deferred.reject(error);
        });
        
        return deferred.promise;
    }
    
    function logout(){
        var deferred = $q.defer();
        
        $http.post(config.apiBase + '/account/logout', {
            headers: {"access_token": $window.localStorage['token']}
        }).then(function(result){
            //$window.localStorage["token"] = null;
            delete $window.localStorage.token;
            delete $window.localStorage.user;
            userInfo = null;
            // remove token from default headers
            $http.defaults.headers.common['x-access-token'] = null;
            tmIdentity.currentUser = undefined;
            deferred.resolve(result);
        }, function(error){
            deferred.reject(error);
        });
        return deferred.promise;
    }
    
    function getUserInfo() {
        return userInfo;
    }
    
    function init(){
        if($window.localStorage['token']){
            userInfo = {
                    accessToken: $window.localStorage['token'],
                    user: getClaimsFromToken($window.localStorage['token'])
                };
        }
        
    }
    
    var tokenClaims = getClaimsFromToken();
    
    
    init();
    
    return {
        login: login,
        logout: logout,
        getUserInfo: getUserInfo,
        getTokenClaims: function () {
            return tokenClaims;
        }
    }
}];


// WEBPACK FOOTER //
// ./app/shell/account/tmAuth.js